// Mapa único de status de plantão usado em todas as telas (Recebíveis, Dashboard,
// Calendário, Vínculo detalhe). O componente visual (badge) vive em shared/ui —
// aqui ficam metadados extras usados em filtros/gráficos.
export { STATUS_META } from "../../../shared/ui/StatusBadge";

export const STATUS_ORDEM = ["em_atraso", "aguardando_nf", "previsto", "recebido"];

// Cores de preenchimento (tokens Chakra) para barras/segmentos por status.
export const STATUS_COLOR_TOKEN = {
  recebido: "success.500",
  aguardando_nf: "warning.500",
  previsto: "teal.400",
  em_atraso: "danger.500",
};

// Status de agenda (calculado, nunca persistido — ver domain.ScheduleStatus no backend):
// indica se a data de trabalho do plantão ainda está no futuro. É um eixo independente do
// status financeiro (STATUS_META acima), por isso usa uma cor que não colide com nenhuma
// delas (success/warning/accent/danger já estão tomadas). Só "scheduled" é exibido como
// badge — "worked" é o estado normal/esperado e não precisa de destaque visual.
export const SCHEDULE_STATUS_META = {
  scheduled: { label: "Agendado", colorScheme: "blue" },
  worked: { label: "Trabalhado", colorScheme: "gray" },
};
